export default __webpack_public_path__ + "static/media/regulatory--pass-on-either-side--g1.ff7956d3.png";